import { useMemo } from 'react';
import { FLOW_TRIGGER } from '../constants';

interface UseAddFlowFormValidationProps {
    currentStep: number;
    selectedTrigger: string;
    selectedDate: string | undefined;
    selectedTime: number | undefined;
}

export const useAddFlowFormValidation = ({
    currentStep,
    selectedTrigger,
    selectedDate,
    selectedTime,
}: UseAddFlowFormValidationProps) => {
    const isDateTriggerActive = selectedTrigger === FLOW_TRIGGER.TIME;

    const canProceedToNextStep = useMemo(() => {
        if (currentStep === 2 && !selectedTrigger) {
            return false;
        }

        if (currentStep === 3 && isDateTriggerActive && (!selectedDate || selectedTime === undefined)) {
            return false;
        }

        return true;
    }, [currentStep, selectedTrigger, selectedDate, selectedTime, isDateTriggerActive]);

    return {
        canProceedToNextStep,
        isDateTriggerActive,
    };
};
